import { Link } from "react-router-dom";
import { useSettings } from "@/context/AppContext";
import { useSeo } from "@/lib/draft";
import { PageHead } from "@/pages/ComoFunciona";

const Draft = ({ published }) =>
  !published && (
    <p className="mb-6 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900" data-testid="legal-draft-banner">
      Versão provisória, sujeita a revisão jurídica antes da publicação comercial.
    </p>
  );

const Body = ({ text, children }) => (
  <article className="wrap mt-10 max-w-3xl space-y-4 leading-relaxed text-[#092C66] [&_h2]:mt-8 [&_h2]:text-xl [&_h2]:font-extrabold">
    {text ? <div className="whitespace-pre-wrap">{text}</div> : children}
  </article>
);

export function Privacidade() {
  const { settings } = useSettings() || {};
  const lp = settings?.legal_pages || {};
  useSeo("Política de Privacidade", "Como a Conexão Litigium trata dados pessoais conforme a LGPD.");
  return (
    <>
      <PageHead eyebrow="Transparência" title="Política de Privacidade" />
      <Body text={lp.privacy_text}>
        <Draft published={lp.privacy_published} />
        <h2>1. Dados coletados</h2>
        <p>Nome completo, estado, telefone celular, e-mail, dados da empresa (quando informados) e o relato da solicitação. Não solicitamos documentos sensíveis no primeiro contato.</p>
        <h2>2. Finalidade</h2>
        <p>Organizar, triar e responder à sua solicitação, entrar em contato pelos meios informados e, se houver interesse mútuo, formalizar proposta de serviços. Não vendemos nem compartilhamos dados com anunciantes.</p>
        <h2>3. Compartilhamento</h2>
        <p>As solicitações são acessadas exclusivamente pelo administrador responsável. Nenhum dado é compartilhado com terceiros profissionais sem sua autorização expressa e específica.</p>
        <h2>4. Armazenamento e segurança</h2>
        <p>Conexão criptografada (HTTPS), controle de acesso no servidor, autenticação multifator do administrador e registros de auditoria. O rascunho da solicitação fica somente no seu dispositivo até o envio.</p>
        <h2>5. Origem de acesso</h2>
        <p>Parâmetros de campanha (UTM) só são registrados quando habilitados pelo administrador. Não utilizamos pixels publicitários.</p>
        <h2>6. Retenção</h2>
        <p>Os dados são mantidos pelo período necessário ao atendimento e ao cumprimento de obrigações legais, sendo eliminados ou anonimizados após esse prazo. [Prazo a definir]</p>
        <h2>7. Seus direitos</h2>
        <p>Você pode solicitar acesso, correção, portabilidade, eliminação ou revogação de consentimento pela área <Link to="/minha-conta" className="font-semibold text-[#1465C8] underline">Minha conta</Link>.</p>
      </Body>
    </>
  );
}

export function Termos() {
  const { settings } = useSettings() || {};
  const lp = settings?.legal_pages || {};
  useSeo("Termos de Uso", "Condições de uso da plataforma Conexão Litigium.");
  return (
    <>
      <PageHead eyebrow="Transparência" title="Termos de Uso" />
      <Body text={lp.terms_text}>
        <Draft published={lp.terms_published} />
        <h2>1. Objeto</h2>
        <p>A Conexão Litigium é uma plataforma tecnológica gratuita para cadastro, envio e acompanhamento de solicitações jurídicas. O uso não gera custo ao usuário, sem prejuízo de honorários eventualmente contratados de forma individual e expressa.</p>
        <h2>2. Ausência de garantias</h2>
        <p>O envio de uma solicitação não implica aceitação de representação profissional, não garante atendimento imediato, não suspende prazos legais e não constitui promessa de resultado.</p>
        <h2>3. Responsabilidades do usuário</h2>
        <p>Fornecer informações verdadeiras, manter seus dados de acesso em sigilo e não enviar conteúdo ilícito ou de terceiros sem autorização.</p>
        <h2>4. Contratação</h2>
        <p>Eventual contratação dependerá de análise profissional, conferência de conflito de interesses e formalização por contrato próprio.</p>
        <h2>5. Alterações</h2>
        <p>Estes termos podem ser atualizados. A versão vigente estará sempre disponível nesta página.</p>
      </Body>
    </>
  );
}
